/* 2026-10-30 albert: distributors miss the price table below the fold. Copy its first rows into a small
   price box just above the Magic Mock-Ups button (after size, color and quantity), with a link
   down to the full table. Falls back to under the price when the page has no Magic Mock-Ups button.
   Logged-out visitors see "MSRP Pricing (R)"; logged-in wholesale customers see their wholesale table instead.
   2026-11-02 albert: the small box now follows the Style drop-down (e.g. RT089 One/Two/Three Colors), the same way
   the full table does: it rebuilds whenever the visible table below changes. */
(function () {
  function visibleTable(list) {
    for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null && list[i].style.display !== 'none' && list[i].rows.length > 1) return list[i]; }
    return null;
  }
  var lastKey = null;
  function build() {
    var wrap = document.getElementById('rg-pricing');
    var price = document.querySelector('.product__info-container [id^="price-"]');
    if (!wrap || !price) return;
    var tables = [].slice.call(wrap.querySelectorAll('table')), t = null, label = 'MSRP Pricing (R)';
    var ws = window.RG_WHOLESALE && wrap.querySelector('.rg-price-label--wholesale');
    if (ws) {
      t = visibleTable(tables.filter(function (x) { return ws.compareDocumentPosition(x) & Node.DOCUMENT_POSITION_FOLLOWING; }));
      if (t) label = 'Wholesale Pricing';
    }
    if (!t) t = visibleTable(tables);
    if (!t) return;
    var rows = [].filter.call(t.rows, function (r) { return r.cells.length > 2; });
    if (rows.length < 2) return;
    var keep = rows.slice(0, 3);
    var key = label + '|' + keep.map(function (r) { return r.textContent.replace(/\s+/g, ' ').trim(); }).join('|');
    var old = document.querySelector('.rg-peek');
    if (old && key === lastKey) return;
    lastKey = key;
    var box = document.createElement('div');
    box.className = 'rg-peek' + (label === 'Wholesale Pricing' ? ' rg-peek--ws' : '');
    var head = document.createElement('div');
    head.className = 'rg-peek__head';
    head.innerHTML = '<span>' + label + '</span><a href="#rg-pricing">Full pricing &darr;</a>';
    box.appendChild(head);
    var tb = document.createElement('table');
    keep.forEach(function (r, n) {
      var tr = document.createElement('tr');
      [].forEach.call(r.cells, function (c) {
        var cell = document.createElement(n === 0 ? 'th' : 'td');
        cell.textContent = c.textContent.trim();
        tr.appendChild(cell);
      });
      tb.appendChild(tr);
    });
    box.appendChild(tb);
    if (label === 'Wholesale Pricing') {
      /* 2026-10-30 albert: wholesale peek takes the same green as the full wholesale table below */
      var bg = function (el) { var c = el && getComputedStyle(el).backgroundColor; return c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)' ? c : null; };
      var dark = bg(rows[0].cells[0]) || bg(rows[0]) || '#2F6B4F';
      var light = bg(rows[1].cells[0]) || bg(rows[1]) || '#EAF4EE';
      box.style.borderColor = dark;
      head.style.background = dark;
      [].forEach.call(tb.rows[0].cells, function (c) { c.style.setProperty('background', light, 'important'); c.style.setProperty('color', dark, 'important'); });
      [].forEach.call(tb.rows, function (r, n) { if (n) r.cells[0].style.setProperty('color', dark, 'important'); });
    }
    if (old) { old.parentNode.replaceChild(box, old); return; }
    var magic = document.querySelector('.product__info-container .rgac-wrap');
    if (magic) magic.parentNode.insertBefore(box, magic);
    else price.parentNode.insertBefore(box, price.nextSibling);
  }
  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(build, 60); }
  function start() {
    build();
    var wrap = document.getElementById('rg-pricing');
    /* the full table below swaps per variant (display / innerHTML); follow it */
    if (wrap && window.MutationObserver) new MutationObserver(soon).observe(wrap, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true, characterData: true });
    /* belt and braces: any variant change on the page */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form, .product__info-container, form[action*="/cart/add"]')) { soon(); setTimeout(build, 400); }
    }, true);
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function () { soon(); setTimeout(build, 400); }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 2026-10-30 albert: move the "Jump to" links (Pricing, Availability, Video, Quick answers) up under the photo thumbnails,
   so the pricing table below starts closer to the fold. */
(function () {
  function move() {
    var nav = document.querySelector('[data-rg-jump]');
    var gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!nav || !gallery || gallery.contains(nav)) return;
    var thumbs = gallery.querySelector('.thumbnail-slider');
    nav.classList.add('rg-jump--under-photos');
    nav.style.margin = '18px 0 0';
    nav.style.flexWrap = 'wrap';
    if (thumbs && thumbs.parentNode) thumbs.parentNode.insertBefore(nav, thumbs.nextSibling);
    else gallery.appendChild(nav);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move); else move();
})();
